import { Col, FormControl, Row } from 'react-bootstrap';
import { Control } from 'forms/rrf';
import BandTarget from './band-target';

const PointsManagementLevel = props => (
  <div>
    <Row>
      <Col md={12}>
        <b>{props.name}</b>
      </Col>
    </Row>
    <BandTarget
      id={props.id}
      line_number='1'
      target_to={props.level ? props.level.band_1_target_to : null}
      model={props.model}
      numberOfProducts={props.numberOfProducts}
    />
    <BandTarget
      id={props.id}
      line_number='2'
      target_to={props.level ? props.level.band_2_target_to : null}
      model={props.model}
      numberOfProducts={props.numberOfProducts}
    />
    <BandTarget
      id={props.id}
      line_number='3'
      target_to={props.level ? props.level.band_3_target_to : null}
      model={props.model}
      numberOfProducts={props.numberOfProducts}
    />
    <Row>
      <Col md={3}>
        <h4>Points to next level</h4>
      </Col>
      <Col md={9}>
        <Control.text
          model={`.levels.${props.id}.points_threshold`}
          component={FormControl}
          placeholder='Enter the number of points to include in the level threshold calculation'
          disabled={!props.nextLevel || props.isEdit}
        />
      </Col>
    </Row>
  </div>
);

export default PointsManagementLevel;
